module.exports = __webpack_public_path__ + "img/banner_mobile.9d8ae956.png";